import React from 'react';

const SocialRegistration = () => {
  return null;
};

export default SocialRegistration;